/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ConversationalAgentStateSchema
 */
export interface ConversationalAgentStateSchema {
  /**
   *
   * @type {number}
   * @memberof ConversationalAgentStateSchema
   */
  readonly id: number;
  /**
   *
   * @type {Array<number>}
   * @memberof ConversationalAgentStateSchema
   */
  readonly fields: Array<number>;
}

/**
 * Check if a given object implements the ConversationalAgentStateSchema interface.
 */
export function instanceOfConversationalAgentStateSchema(value: object): value is ConversationalAgentStateSchema {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('fields' in value) || value['fields'] === undefined) return false;
  return true;
}

export function ConversationalAgentStateSchemaFromJSON(json: any): ConversationalAgentStateSchema {
  return ConversationalAgentStateSchemaFromJSONTyped(json, false);
}

export function ConversationalAgentStateSchemaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ConversationalAgentStateSchema {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    fields: json['fields'],
  };
}

export function ConversationalAgentStateSchemaToJSON(
  value?: Omit<ConversationalAgentStateSchema, 'id' | 'fields'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {};
}
